import { render, staticRenderFns } from "./CarouselGallery.vue?vue&type=template&id=51c18a60"
import script from "./CarouselGallery.vue?vue&type=script&lang=js"
export * from "./CarouselGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports